/* Product card hover crossfade - the second image's source, supplied late.

   The card renders its second image with NO `src` and no `srcset`, only data
   attributes. An <img> without a source makes no network request, so a
   60-product grid costs exactly what it did before on every device, and a
   phone never fetches a hover image it can never show.

   This fills the source in once, on the first pointer enter, and only where a
   real hover exists at >=1024 - the same condition the CSS uses. Delegated
   from the document, so cards appended by Load More or swapped in by the
   filter rail are covered without rebinding.

   No JS, no swap: the first image stays, nothing breaks. */
(function () {
  var QUERY = '(hover: hover) and (pointer: fine) and (min-width: 1024px)';
  if (!window.matchMedia || !window.matchMedia(QUERY).matches) return;

  function fill(card) {
    var alt = card.querySelector('.ob-card__image--alt');
    if (!alt || alt.dataset.obAltLoaded === '1') return;
    alt.dataset.obAltLoaded = '1';
    var srcset = alt.getAttribute('data-ob-alt-srcset');
    var src = alt.getAttribute('data-ob-alt-src');
    if (srcset) alt.setAttribute('srcset', srcset);
    if (src) alt.setAttribute('src', src);
  }

  // pointerover bubbles, unlike pointerenter, so one listener covers every card
  document.addEventListener('pointerover', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var card = t.closest('.ob-card');
    if (card) fill(card);
  }, { passive: true });

  // keyboard users reach the card through its link, which never fires pointerover
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var card = t.closest('.ob-card');
    if (card) fill(card);
  });
})();
